import React, { useState } from 'react'
import {
  Box,
  Typography,
  Button,
  IconButton,
  List,
  ListItem,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import DeleteIcon from '@mui/icons-material/Delete'
import useNotification from './common/Notification'
import ApiEndPoints from './common/ApiEndpoints'

const Upload = () => {
  const showNotification = useNotification()

  const [formData, setFormData] = useState({
    sub_type: '',
    type: '',
    template_status: '',
    valid_date: '',
    img_url: '',
  })

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!formData.img_url.endsWith('.jpg')) {
      showNotification('Only JPG,PNG,or JPEG photo is allowed', 'warning')
      return
    }
    if (!formData.img_url.endsWith('.png')) {
      showNotification('Only JPG,PNG,or JPEG photo is allowed', 'warning')
      return
    }

    if (!formData.img_url.endsWith('.jpeg')) {
      showNotification('Only JPG,PNG,or JPEG photo is allowed', 'warning')
      return
    }

    try {
      const response = await ApiEndPoints.uploadAndShare(formData)
      console.log(response)
      showNotification(response.data.message, 'success', 3000)
      setTimeout(() => {
        window.location.reload()
      }, 3100)
    } catch (error) {
      showNotification(error.response?.data?.data?.message, 'error', 3000)
      setTimeout(() => {
        window.location.reload()
      }, 3100)
    }
  }

  const [files, setFiles] = useState([])
  const handleDrop = (event) => {
    event.preventDefault()
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const droppedFile = event.dataTransfer.files[0]
      setFiles([droppedFile])
      event.dataTransfer.clearData()
    }
  }
  const handleFileSelect = (event) => {
    if (event.target.files.length > 0) {
      const selectedFile = event.target.files[0]
      setFiles([selectedFile])
    }
  }

  const handleDragOver = (event) => {
    event.preventDefault()
  }

  const handleRemoveFile = () => {
    setFiles([])
  }

  return (
    <Box
      sx={{
        margin: '4rem auto',
        marginTop: '5rem ',
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        display: { xs: 'contents', md: 'flex' },
        flexWrap: 'wrap',
        flexDirection: 'row',
        padding: '25px',
        boxShadow: '0px 4px 10px rgba(0,0,0,0.2)',
        width: '75%',
        gap: 4,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '400px',
          padding: 3,
          borderRadius: 2,
          backgroundColor: '#fff',
          textAlign: 'center',
          '@media (max-width: 768px)': {
            marginLeft: -6,
            marginTop: 2,
          },
        }}
      >
        <Typography
          variant="h4"
          mb={2}
          sx={{
            fontWeight: 'bold',
            color: 'primary.main',
            '@media (max-width: 768px)': {
              // marginLeft: -6,
              fontSize: '23px',
              marginBottom: 1,
            },
          }}
        >
          Fill the Details
        </Typography>
        <form
          onSubmit={handleSubmit}
          sx={{
            textAlign: 'start',
          }}
        >
          <TextField
            fullWidth
            label="Party name"
            name="sub_type"
            value={formData.sub_type}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            required
          />

          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              name="template_status"
              value={formData.template_status}
              onChange={handleChange}
              label="Status"
              required
            >
              <MenuItem value="ENABLED">Enable</MenuItem>
              <MenuItem value="DISABLED">Disable</MenuItem>
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Due Date"
            name="valid_date"
            type="date"
            value={formData.valid_date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            margin="normal"
            required
          />
          {/* Image Link Input Field */}
          <TextField
            fullWidth
            label="Image URL"
            name="img_url"
            value={formData.img_url}
            // onChange={handleImageInput}
            onChange={handleChange}
            variant="outlined"
            margin="normal"
            required
            InputProps={{ readOnly: false }} // Allow user to enter manually
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ marginTop: 2 }}
          >
            Submit
          </Button>
        </form>
      </Box>

      {/* Drag & Drop Box */}
      <Box
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        sx={{
          borderRadius: 5,
          padding: 6,
          marginTop: 9,
          backgroundColor: 'white',
          cursor: 'pointer',
          width: '90%',
          minWidth: '280px',
          maxWidth: '400px',

          border: '2px solid #ddd',
          textAlign: 'center',
          '&:hover': { backgroundColor: '#e9ecef' },
          '@media (max-width: 768px)': {
            minWidth: '90%',
            marginLeft: -8,
            marginBottom: 9,
            marginTop: 3,
          },
        }}
      >
        <Box>
          <CloudUploadIcon
            sx={{
              fontSize: '6rem',
              color: 'primary.main',
              '@media (max-width: 768px)': {
                fontSize: '4rem',
                marginTop: -1,
              },
            }}
          />
        </Box>
        <Typography
          variant="h5"
          sx={{
            marginTop: 2,
            fontWeight: 'bold',
            '@media (max-width: 768px)': {
              fontSize: '1rem',
            },
          }}
        >
          Drag & Drop files here
        </Typography>

        <Button
          variant="contained"
          component="label"
          sx={{
            marginTop: 3,
            fontWeight: 'bold',
            fontSize: '1rem',
            padding: '8px 20px',
            borderRadius: '50px',
            '@media (max-width: 768px)': {
              marginTop: 2,
              padding: '3px 10px',
            },
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Browse
          </Typography>
          <input type="file" hidden multiple onChange={handleFileSelect} />
        </Button>

        {files.length > 0 && (
          <Box sx={{ marginTop: 3 }}>
            <List>
              {files.map((file, index) => (
                <ListItem
                  // key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    border: '1px solid #ddd',
                    borderRadius: 2,
                    padding: 1,
                    marginBottom: 1,
                    backgroundColor: 'white',
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: '#f1f1f1' },
                    '@media (max-width: 768px)': {
                      marginTop: -1,
                      padding: '0px 12px',
                      marginBottom: -3,
                    },
                  }}
                >
                  <Typography
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '150px',
                    }}
                  >
                    {file.name}
                  </Typography>
                  <IconButton
                    onClick={() => handleRemoveFile(index)}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItem>
              ))}{' '}
            </List>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Upload
